export interface FontOption {
  id: string;
  label: string;
  sample: string;
  stack: string;
}

export const fontOptions: FontOption[] = [
  { id: "inter", label: "Inter", sample: "Command Center 7894.75", stack: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Arial, sans-serif" },
  { id: "segoe", label: "Segoe UI", sample: "Plan Builder 5.0%", stack: "\"Segoe UI\", system-ui, -apple-system, BlinkMacSystemFont, Arial, sans-serif" },
  { id: "arial", label: "Arial", sample: "Allocation Matrix", stack: "Arial, Helvetica, ui-sans-serif, sans-serif" },
  { id: "roboto", label: "Roboto", sample: "Risk Desk 10Y Range", stack: "Roboto, \"Segoe UI\", Arial, sans-serif" },
  { id: "helvetica", label: "Helvetica", sample: "Chart Intelligence", stack: "\"Helvetica Neue\", Helvetica, Arial, sans-serif" },
  { id: "avenir", label: "Avenir", sample: "Execution Ledger", stack: "Avenir, \"Avenir Next\", \"Segoe UI\", Arial, sans-serif" },
  { id: "plex", label: "IBM Plex Sans", sample: "Trigger -5.0%", stack: "\"IBM Plex Sans\", \"Segoe UI\", Arial, sans-serif" },
  { id: "noto", label: "Noto Sans", sample: "Global Monitoring", stack: "\"Noto Sans\", \"Segoe UI\", Arial, sans-serif" },
  { id: "source", label: "Source Sans 3", sample: "Telegram Alerts", stack: "\"Source Sans 3\", \"Source Sans Pro\", \"Segoe UI\", Arial, sans-serif" },
  { id: "trebuchet", label: "Trebuchet MS", sample: "Dashboard Control", stack: "\"Trebuchet MS\", \"Segoe UI\", Arial, sans-serif" }
];

export const defaultFontStack = fontOptions[0].stack;

export function applyFontPreference(fontFamily: string) {
  document.documentElement.style.setProperty("--sans", fontFamily || defaultFontStack);
}
